import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { OrigemID } from '../../../common/origens/domain';
import { isTipoPessoaFisica, isTipoPessoaJuridica } from '../../tipo';
import { Cliente } from '../cliente';

interface Config {
    isOrigemCampanha: boolean;
    isOrigemMidiaSocial: boolean;
    isTipoPessoaFisica: boolean;
    isTipoPessoaJuridica: boolean;
}

@Component({
    selector: 'sgt-cliente-form-info',
    templateUrl: './cliente-form-info.component.html',
    styleUrls: ['./cliente-form-info.component.less']
})
export class ClienteFormInfoComponent implements OnChanges {
    config: Config;

    @Input() entity: Cliente;

    ngOnChanges(changes: SimpleChanges) {
        for (const propName in changes) {
            if (propName === 'entity') {
                if (!changes[propName].isFirstChange()) {
                    this.setConfig();
                }
            }
        }
    }

    private setConfig() {
        this.config = {
            isOrigemCampanha: OrigemID.isOrigemCampanha(this.entity?.origem ?? null),
            isOrigemMidiaSocial: OrigemID.isOrigemMidiaSocial(this.entity?.origem ?? null),
            isTipoPessoaFisica: isTipoPessoaFisica(this.entity?.pessoa?.tipo),
            isTipoPessoaJuridica: isTipoPessoaJuridica(this.entity?.pessoa?.tipo),
        };
    }
}
